import { createFeatureSelector } from '@ngrx/store';

import { ANALYTICS_ENTITIES_STATE_KEY } from '../constants';
import { State } from '../interfaces';

export const selectAnalyticsState = createFeatureSelector<State>(
  ANALYTICS_ENTITIES_STATE_KEY,
);
